import React from 'react';
import './Spinner.css';
import logoGala from '../assets/common/LogoGala.png';

// Icône de chargement réutilisable : le logo CycleGala qui se gonfle et se
// dégonfle en boucle (pulsation). `size` en px.
const Spinner = ({ size = 32, label = 'Chargement', className = '' }) => (
  <span
    className={`spinner${className ? ` ${className}` : ''}`}
    role="status"
    aria-label={label}
    style={{ width: size, height: size }}
  >
    <img src={logoGala} alt="" aria-hidden="true" className="spinner__logo" />
    <span className="spinner__sr">{label}…</span>
  </span>
);

export default Spinner;
